import { render, staticRenderFns } from "./Prediction1.vue?vue&type=template&id=a74f6d7e&scoped=true"
import script from "./Prediction1.vue?vue&type=script&lang=js"
export * from "./Prediction1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74f6d7e",
  null
  
)

export default component.exports